<template>
  <dx-deadline-form
    next-step-path="SelfService-ReportDamage-Counterparty"
    previous-step-path="SelfService-ReportDamage-DocumentUpload"
  />
</template>

<script>
import DxDeadlineForm from '~/components/reportDamage/DX-DeadlineForm'

export default {
  name: 'ReportDamageDeadline',
  components: {
    DxDeadlineForm,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/kundencenter/schaden-melden/frist',
      fr: '/centre-clients/dommages-rapport/date-limite',
      it: '/cliente/danni-report/scadenza',
    },
  },
}
</script>
